import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Cake } from "lucide-react";
import { trpc } from "@/trpc";
import { formatMonthDay } from "@satyrsmc/shared/lib/date-utils";

/** Members-area dashboard widget — visible to any logged-in member, not admin-gated. */
export function BirthdaysThisMonthCard() {
  const { data, isLoading } = trpc.members.roster.birthdaysThisMonth.useQuery();
  const birthdays = data ?? [];

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between pb-2">
        <CardTitle className="text-sm font-medium text-muted-foreground">
          Birthdays This Month
        </CardTitle>
        <Cake className="size-4 text-muted-foreground" />
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="space-y-2">
            {(["s0", "s1", "s2"] as const).map((k) => (
              <div key={k} className="h-5 animate-pulse rounded bg-muted" />
            ))}
          </div>
        ) : birthdays.length > 0 ? (
          <ul className="space-y-2">
            {birthdays.map((m) => (
              <li key={m.id} className="flex items-center justify-between text-sm">
                <span className="font-medium truncate max-w-[180px]">{m.display_name}</span>
                <span className="ml-2 shrink-0 text-muted-foreground">
                  {formatMonthDay(m.birthday)}
                </span>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-sm text-muted-foreground">No birthdays this month.</p>
        )}
      </CardContent>
    </Card>
  );
}
